import React, { Component } from 'react';
import {connect} from 'react-redux';
import { getAllDemographicsDataByUser} from '../../actions/country';
import UserDemographicsDataList from '../../components/country/userDemographicsData';


class UserDemographicsData extends Component {
  constructor(props){
    super(props)

    this.queryString = window.location.href;
    this.catid =this.queryString.split("&catId=")[1].split('&')[0];
    this.uid =this.queryString.split('&UID=')[1];  //participant id 
    this.state = {
        uid : this.uid,
        catid : this.catid
    }
  }

  
  componentWillMount() {
    this.props.dispatch(getAllDemographicsDataByUser( this.state.catid, this.state.uid));
  }

  

  render(){
    
    let showDemographicsDataView = <UserDemographicsDataList
      userDemographicsDataSuccess = {this.props.userDemographicsDataSuccess}
      userDemographicsData = {this.props.userDemographicsData}
    />
      
    return (
        <div> 
             {showDemographicsDataView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    userDemographicsDataSuccess : state.country.userDemographicsDataSuccess,
    userDemographicsData : state.country.userDemographicsData,
  }
}

export default connect(mapStateToProps)(UserDemographicsData);



// WEBPACK FOOTER //
// ./src/pages/country/userDemographicsData.js